import { render, staticRenderFns } from "./OrderRecycle.vue?vue&type=template&id=6f410d1b&scoped=true&"
import script from "./OrderRecycle.vue?vue&type=script&lang=js&"
export * from "./OrderRecycle.vue?vue&type=script&lang=js&"
import style0 from "./OrderRecycle.vue?vue&type=style&index=0&id=6f410d1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f410d1b",
  null
  
)

export default component.exports